import { Plus, Wallet as WalletIcon } from 'lucide-react'
import type { Wallet } from '../../lib/types'
import { Button, Card } from '../ui'
import { formatBalance } from './money'

interface WalletBalanceCardProps {
  wallet: Wallet
  /** From getStripePublishableKey(); null ⇒ payments not configured here. */
  publishableKey: string | null
  /** Opens the top-up flow (TopUpDialog) — the parent owns the dialog. */
  onAddFunds: () => void
  className?: string
}

/**
 * Wallet balance headline + "Add funds" CTA. Purely presentational: the
 * balance is the server's ledger truth. When Stripe isn't configured the CTA
 * disables and the card says so instead of pretending (§3.7 degraded UI).
 */
export function WalletBalanceCard({ wallet, publishableKey, onAddFunds, className }: WalletBalanceCardProps) {
  const degraded = publishableKey === null

  return (
    <Card elevation="raised" className={className}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="flex items-center gap-1.5 text-sm text-text-muted">
            <WalletIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" />
            Wallet balance
          </p>
          <p className="mt-1 font-display text-4xl tracking-tight text-text-strong">
            {formatBalance(wallet.balance_cents, wallet.currency)}
          </p>
        </div>
        <Button onClick={onAddFunds} disabled={degraded}>
          <Plus className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" />
          Add funds
        </Button>
      </div>
      {degraded && (
        <p className="mt-3 text-sm text-warning-fg">
          Payments aren&rsquo;t configured in this environment.
        </p>
      )}
    </Card>
  )
}
